<template>
  <div>
    <MainPage v-if="loaded">
      <template #gridlinks>
        <div
          class="grid-links d-flex flex-row"
          :class="{ empty: !gridLinks || gridLinks.length == 0 }"
        >
          <div class="grid-links-left">
            <v-responsive
              class="grid-link"
              v-for="(card, index) in gridLinksLeft"
              :key="index"
              :aspect-ratio="aspectRatio(card)"
              :class="`grid-link-size-${card.size}`"
            >
              <v-component
                :is="card.external_link ? 'a' : 'router-link'"
                :target="card.external_link ? '_blank' : ''"
                :href="card.external_link ? card.link : false"
                :to="!card.external_link ? card.link : false"
              >
                <div
                  class="grid-link__bg"
                  :style="{
                    backgroundImage: `url(${card.preview_urls.large})`
                  }"
                ></div>
                <div class="grid-link__content">
                  <div class="grid-link__title">{{ card.title }}</div>
                  <div class="grid-link__description">
                    {{ card.description }}
                  </div>
                </div>
              </v-component>
            </v-responsive>
          </div>
          <div v class="grid-links-right">
            <v-responsive
              class="grid-link"
              v-for="(card, index) in gridLinksRight"
              :key="index"
              :aspect-ratio="aspectRatio(card)"
              :class="`grid-link-size-${card.size}`"
            >
              <v-component
                :is="card.external_link ? 'a' : 'router-link'"
                :target="card.external_link ? '_blank' : ''"
                :href="card.external_link ? card.link : false"
                :to="!card.external_link ? card.link : false"
              >
                <div
                  class="grid-link__bg"
                  :style="{
                    backgroundImage: `url(${card.preview_urls.large})`
                  }"
                ></div>
                <div class="grid-link__content">
                  <div class="grid-link__title">{{ card.title }}</div>
                  <div class="grid-link__description">
                    {{ card.description }}
                  </div>
                </div>
              </v-component>
            </v-responsive>
          </div>
        </div>
        <TerminusSectionHeader name="winners" :alt="'Winners'" />
      </template>
      <template #main>
        <TerminusSectionHeader name="schedule" :alt="'Schedule'" />
        <ScheduleWrapper />
        <TerminusSectionHeader name="partners" :alt="'Partners'" />
        <Partners />
        <Questions />
      </template>
    </MainPage>
  </div>
</template>

<script>
import { mapState } from "vuex";

import MainPage from "./main.page";

export default {
  name: "HomePage",
  components: { MainPage },
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.setPageContext("home", () => {
      this.loaded = true;
    });
  },
  methods: {
    aspectRatio(card) {
      const aspectRatio = card.size == "full" ? 16 / 9 : 16 / 4.5;
      return ["xl", "lg", "md"].includes(this.$size) ? aspectRatio : 335 / 330;
    }
  },
  computed: {
    gridLinksLeft() {
      return this.gridLinks?.filter(g => g.side == "left") || [];
    },
    gridLinksRight() {
      return this.gridLinks?.filter(g => g.side == "right") || [];
    },
    ...mapState({
      gridLinks: state => state.page.active?.grid_links
    })
  }
  //2.37
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.grid-links {
  position: relative;
  display: flex;
  padding: 80px 120px;
  border-bottom: solid 2px #34494c;
  @media screen and (max-width: 1264px) {
    padding: 80px 56px;
  }
  &.empty {
    padding: 0 !important;
    border-bottom: none !important;
    .grid-links-left {
      @media screen and (max-width: 960px) {
        margin-bottom: 0 !important;
      }
    }
  }

  &-left,
  &-right {
    flex-basis: 50%;
  }
  &-left {
    @media screen and (max-width: 960px) {
      margin-bottom: 20px;
    }
    @media screen and (min-width: 961px) {
      margin-right: 20px;
    }
  }
}

.grid-link {
  border-radius: 10px;
  &:hover {
    opacity: 0.8;
  }

  &__overlay,
  &__bg {
    opacity: 0.8;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  &__bg {
    background-size: cover;
    background-position: center;
  }

  &__content {
    padding: 30px;
    position: relative;
    height: 100%;
    text-align: left;
    color: white;
    display: flex;
    align-items: flex-end;
    background: linear-gradient(180deg, rgba(52, 73, 76, 0) 50%, #34494c 100%);
  }

  &__title {
    font-weight: 700;
    font-size: 20px;
    line-height: 1;
  }

  &__description {
    font-weight: bold;
    font-size: 18px;
    line-height: 1.44;
  }

  a {
    text-decoration: none;
  }

  &-size-full {
    height: 100%;
  }

  &-size-half {
    &:not(:last-child) {
      margin-bottom: 20px;
    }

    .grid-link__content::before {
      top: 15px;
    }
  }
}

@media screen and (max-width: 1264px) {
  .grid-links {
    padding: 30px 56px;
  }
}

@media screen and (max-width: 960px) {
  .grid-links {
    padding: 40px 20px;
    flex-wrap: wrap;

    &-left,
    &-right {
      flex-basis: 100%;
    }
  }
  .grid-link {
    min-height: 175px;
  }
}
</style>
